(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coming-soon"]) return;
  try {
    
(function () {
  var CLICK_SLOP = 8;   // px of travel still counted as a click, not a drag
  var CLICK_TIME = 500; // ms

  function initSection(section) {
    var stack = section.querySelector('[data-cs-stack]');
    if (!stack) return;

    var cards = Array.prototype.slice.call(stack.querySelectorAll('[data-cs-card]'));
    if (!cards.length) return;

    var css = getComputedStyle(section);
    var maxZoom = parseFloat(css.getPropertyValue('--cs-max-zoom')) || 3;
    var scatter = parseFloat(css.getPropertyValue('--cs-scatter'));
    var tilt = parseFloat(css.getPropertyValue('--cs-tilt'));
    if (isNaN(scatter)) scatter = 40;
    if (isNaN(tilt)) tilt = 12;
    var minZoom = 1;
    var margin = 48; // px of a drawing that must stay on screen

    function rand(min, max) { return min + Math.random() * (max - min); }
    function dist(a, b) { return Math.hypot(a.x - b.x, a.y - b.y); }
    function mid(a, b) { return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }; }
    function clampScale(s) { return Math.min(maxZoom, Math.max(minZoom, s)); }

    // The original artwork (first card) stays square-on at the top of the pile;
    // the rest are shuffled and scattered underneath, fresh on every page load.
    var hero = cards[0];
    var buried = cards.slice(1);
    for (var i = buried.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var swap = buried[i]; buried[i] = buried[j]; buried[j] = swap;
    }
    var order = [hero].concat(buried); // index 0 == top of the pile

    var state = new Map();
    cards.forEach(function (card) {
      state.set(card, {
        x: card === hero ? 0 : rand(-scatter, scatter),
        y: card === hero ? 0 : rand(-scatter, scatter),
        r: card === hero ? 0 : rand(-tilt, tilt),
        scale: 1,
        base: null
      });
    });

    function apply(card) {
      var s = state.get(card);
      card.style.transform =
        'translate(' + s.x + 'px,' + s.y + 'px) rotate(' + s.r + 'deg) scale(' + s.scale + ')';
    }

    function applyOrder() {
      order.forEach(function (card, idx) {
        card.style.zIndex = String(order.length - idx);
      });
    }

    // Click anywhere on the pile: the bottom drawing surfaces to the top.
    function cycle() {
      if (order.length < 2) return;
      order.unshift(order.pop());
      applyOrder();
    }

    // Measure a card's untransformed drawing (the image, not its full-bleed box).
    function measure(card) {
      var s = state.get(card);
      var prev = card.style.transform;
      card.style.transform = 'none';
      var img = card.querySelector('img');
      var r = (img || card).getBoundingClientRect();
      card.style.transform = prev;
      s.base = { cx: r.left + r.width / 2, cy: r.top + r.height / 2, w: r.width, h: r.height };
    }

    // Keep a drawing from leaving the viewport (at least `margin` px stays visible).
    function clampTranslate(card) {
      var s = state.get(card);
      if (!s.base) return;
      var halfW = (s.base.w * s.scale) / 2;
      var halfH = (s.base.h * s.scale) / 2;
      var cx = s.base.cx + s.x;
      var cy = s.base.cy + s.y;
      var minCx = margin - halfW, maxCx = window.innerWidth - margin + halfW;
      var minCy = margin - halfH, maxCy = window.innerHeight - margin + halfH;
      cx = Math.min(maxCx, Math.max(minCx, cx));
      cy = Math.min(maxCy, Math.max(minCy, cy));
      s.x = cx - s.base.cx;
      s.y = cy - s.base.cy;
    }

    cards.forEach(function (card) {
      var img = card.querySelector('img');
      if (!img) return;

      var pointers = new Map();
      var gesture = null;
      var travel = 0;
      var downAt = 0;

      function baseline() {
        var s = state.get(card);
        var pts = Array.from(pointers.values());
        gesture = { x: s.x, y: s.y, scale: s.scale };
        if (pts.length >= 2) {
          gesture.dist = dist(pts[0], pts[1]);
          gesture.mid = mid(pts[0], pts[1]);
        } else if (pts.length === 1) {
          gesture.mid = { x: pts[0].x, y: pts[0].y };
        }
      }

      img.addEventListener('pointerdown', function (e) {
        img.setPointerCapture(e.pointerId);
        pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
        if (pointers.size === 1) {
          travel = 0;
          downAt = e.timeStamp;
          measure(card);
        }
        card.classList.add('is-grabbing');
        baseline();
      });

      img.addEventListener('pointermove', function (e) {
        if (!pointers.has(e.pointerId) || !gesture) return;
        var prev = pointers.get(e.pointerId);
        travel += Math.hypot(e.clientX - prev.x, e.clientY - prev.y);
        pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

        var s = state.get(card);
        var pts = Array.from(pointers.values());
        if (pts.length >= 2) {
          var d = dist(pts[0], pts[1]);
          var m = mid(pts[0], pts[1]);
          s.scale = clampScale(gesture.scale * (d / gesture.dist));
          s.x = gesture.x + (m.x - gesture.mid.x);
          s.y = gesture.y + (m.y - gesture.mid.y);
        } else {
          var p = pts[0];
          s.x = gesture.x + (p.x - gesture.mid.x);
          s.y = gesture.y + (p.y - gesture.mid.y);
        }
        clampTranslate(card);
        apply(card);
      });

      function release(e) {
        if (!pointers.has(e.pointerId)) return;
        pointers.delete(e.pointerId);
        if (pointers.size === 0) {
          gesture = null;
          card.classList.remove('is-grabbing');
          // Barely moved, released quickly? That was a click, not a drag.
          if (travel < CLICK_SLOP && (e.timeStamp - downAt) < CLICK_TIME) cycle();
        } else {
          baseline(); // re-baseline the remaining pointer(s)
        }
      }
      img.addEventListener('pointerup', release);
      img.addEventListener('pointercancel', release);

      img.addEventListener('click', function (e) { e.preventDefault(); });
    });

    function remeasure() {
      cards.forEach(function (card) {
        measure(card);
        clampTranslate(card);
        apply(card);
      });
    }

    applyOrder();
    cards.forEach(apply);

    cards.forEach(function (card) {
      var img = card.querySelector('img');
      if (img && !img.complete) img.addEventListener('load', function () {
        measure(card);
        clampTranslate(card);
        apply(card);
      });
    });
    window.addEventListener('resize', remeasure);
    window.addEventListener('load', remeasure);
    remeasure();
  }

  document.querySelectorAll('[data-section-type="coming-soon"]').forEach(initSection);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // The stars fill as one drawing. Hover on a pointer; on a phone a tap fills
  // and a second tap clears, since there is no hover to leave.
  (function () {
    document.querySelectorAll('[data-gw-stars]').forEach(function (stars) {
      var wash = stars.querySelector('[data-gw-star-wash]');
      if (!wash) return;

      function set(on) {
        wash.classList.toggle('is-on', on);
        // Restart the animation rather than letting a second hover find the
        // class already there and do nothing.
        stars.classList.remove('is-on');
        if (on) { void stars.offsetWidth; stars.classList.add('is-on'); }
      }

      stars.addEventListener('pointerenter', function (event) {
        if (event.pointerType === 'touch') return;
        set(true);
      });

      stars.addEventListener('pointerleave', function (event) {
        if (event.pointerType === 'touch') return;
        set(false);
      });

      stars.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'touch') return;
        set(!wash.classList.contains('is-on'));
      });
    });
  })();


  // The drawing that follows the links, restored — an earlier edit to the star
  // script took this with it. It also now carries the colour wash: one layer
  // masked to whichever drawing is showing, rather than one per drawing.
  (function () {
    document.querySelectorAll('[data-gw-footer]').forEach(function (footer) {
      var stage = footer.querySelector('[data-gw-icon-stage]');
      var scope = footer.querySelector('[data-gw-icon-scope]');
      if (!stage || !scope) return;

      var images = stage.querySelectorAll('[data-gw-icon-for]');
      var resting = images[0] ? images[0].getAttribute('data-gw-icon-for') : null;
      function show(key) {
        images.forEach(function (img) {
          img.classList.toggle('is-active', img.getAttribute('data-gw-icon-for') === key);
        });
      }

      footer.querySelectorAll('[data-gw-icon]').forEach(function (link) {
        var key = link.getAttribute('data-gw-icon');
        function enter() { show(key); }
        link.addEventListener('mouseenter', enter);
        link.addEventListener('focus', enter);
        link.addEventListener('blur', function () { show(resting); });
      });

      // The reset lives on the list, not on each link. Per-link mouseleave fired
      // on the way from one link to the next, so the sun flashed up between
      // every pair. Leaving the list is the only thing that should reset it.
      scope.addEventListener('mouseleave', function () { show(resting); });

    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gw-region-gate"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-gw-region]');
    if (!root) return;

    var dialog = root.querySelector('dialog');
    var key = root.getAttribute('data-storage-key') || 'gw-region';
    if (!dialog || typeof dialog.showModal !== 'function') return;

    function remembered() {
      try { return localStorage.getItem(key); } catch (e) { return null; }
    }
    function remember(v) {
      try { localStorage.setItem(key, v); } catch (e) {}
    }

    // The gw-region parameter does three jobs:
    //   reset      forget the choice and ask again (this is how you review it)
    //   geo, intl  a choice arriving from the other domain — record it and
    //              stay quiet, so nobody is asked twice for the same answer
    var param = (location.search.match(/[?&]gw-region=([a-z]+)/) || [])[1];
    if (param === 'reset') {
      try { localStorage.removeItem(key); } catch (e) {}
    } else if (param === 'geo' || param === 'intl') {
      remember(param);
    }

    // Never interrupt someone who already chose, and never ask inside the theme
    // editor, where an undismissable dialog would block the preview entirely.
    if (remembered()) return;
    if (window.Shopify && window.Shopify.designMode) return;

    // hold the cookie banner back until this is answered — see gw-base.css
    var html = document.documentElement;
    html.classList.add('gw-gate-open');

    root.hidden = false;
    dialog.showModal();

    // a dialog focuses its first focusable child, which would put a visible
    // ring on one of the two choices. Land on the heading instead.
    var title = dialog.querySelector('.gw-region__title');
    if (title) title.focus({ preventScroll: true });

    // Escape fires `cancel` before `close`; refusing it is the only way to keep
    // a modal dialog open, since there is no attribute for it.
    dialog.addEventListener('cancel', function (event) { event.preventDefault(); });

    dialog.addEventListener('click', function (event) {
      var choice = event.target.closest('[data-gw-region-choice]');
      if (!choice) return;               // clicks on the backdrop do nothing
      remember(choice.getAttribute('data-gw-region-choice'));
      // the Georgia option is a real link — let it navigate on its own
      if (choice.tagName !== 'A') {
        event.preventDefault();
        dialog.close();
      }
    });

    dialog.addEventListener('close', function () {
      html.classList.remove('gw-gate-open');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.gw-header__toggle');

    if (toggle) {
      var drawer = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!drawer) return;
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      drawer.hidden = open;
      return;
    }

    // A tap anywhere else closes it — but not one inside the panel, which is
    // where the links are. There is no backdrop to catch this, since the menu
    // is an island rather than a full-screen overlay, so it listens on the
    // document instead.
    var open_drawer = document.querySelector('.gw-drawer:not([hidden])');
    if (!open_drawer || open_drawer.contains(event.target)) return;
    open_drawer.hidden = true;
    var btn = document.querySelector('[aria-controls="' + open_drawer.id + '"]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  });

  // Escape closes it too, and focus goes back to the button that opened it
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open_drawer = document.querySelector('.gw-drawer:not([hidden])');
    if (!open_drawer) return;
    open_drawer.hidden = true;
    var btn = document.querySelector('[aria-controls="' + open_drawer.id + '"]');
    if (btn) { btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
  });

  (function () {
    var root = document.querySelector('[data-gw-searchmodal]');
    if (!root) return;

    var dialog = root.querySelector('dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    var input = dialog.querySelector('[data-gw-suggest-input]');
    var closer = dialog.querySelector('[data-gw-searchmodal-close]');

    var panel = dialog.querySelector('[data-gw-suggest-panel]');

    // The list hangs below the field, so what bounds it is the room left under
    // the field — not a share of the viewport. Measured rather than assumed.
    function fit() {
      if (!panel || !dialog.open) return;
      var top = panel.getBoundingClientRect().top;
      var room = window.innerHeight - top - 16;
      panel.style.setProperty('--gw-suggest-max', Math.max(140, room) + 'px');
    }

    function open(event) {
      // Let a modified click through — someone opening search in a new tab
      // wants the page, not an overlay they cannot see.
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
      event.preventDefault();
      root.hidden = false;
      dialog.showModal();
      if (input) input.focus();
      fit();
    }

    window.addEventListener('resize', fit);

    // Measuring at open time reads the panel while it is still empty and sitting
    // higher than it will end up, so the ceiling comes out too generous. Measure
    // again whenever results actually land in it.
    if (panel && 'MutationObserver' in window) {
      new MutationObserver(fit).observe(panel, { childList: true });
    }

    document.querySelectorAll('[data-gw-search-open]').forEach(function (link) {
      link.addEventListener('click', open);
    });

    if (closer) closer.addEventListener('click', function () { dialog.close(); });

    // Clicks land on the dialog itself only when they miss the panel inside it,
    // which is the backdrop as far as anyone looking at it is concerned.
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('close', function () { root.hidden = true; });
  })();

  /* ------------------------------------------------------------------
     Behaviour that belongs to the whole site rather than to one section.

     Shopify gates a section's {% javascript %} behind a check for that
     section being on the page — `if (!__sections__["name"]) return` — so a
     rail on the product page would never have got the script that lived in
     the collection block, and the header's search modal would never have got
     the one that lived in the search section. The header is on every page, so
     this is where those two live.
     ------------------------------------------------------------------ */

  /* Arrows for every .gw-rail on the site. Section javascript is concatenated
     into one file served on every page, so this lives in one section rather
     than being copied into each one that renders a rail. */
  (function () {
    document.querySelectorAll('[data-gw-rail]').forEach(function (rail) {
      var track = rail.querySelector('[data-gw-rail-track]');
      if (!track) return;

      var prev = rail.querySelector('[data-gw-rail-prev]');
      var next = rail.querySelector('[data-gw-rail-next]');

      function scrollable() {
        return track.scrollWidth - track.clientWidth > 1;
      }

      function sync() {
        rail.classList.toggle('is-scrollable', scrollable());
        var left = track.scrollLeft;
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = left <= 1;
        if (next) next.disabled = left >= max - 1;
      }

      // A page at a time — with four cards visible that is four cards, which
      // is what the arrow looks like it should do.
      function page(direction) {
        track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { page(-1); });
      if (next) next.addEventListener('click', function () { page(1); });

      var frame = null;
      track.addEventListener('scroll', function () {
        if (frame) return;
        frame = requestAnimationFrame(function () {
          frame = null;
          sync();
        });
      }, { passive: true });

      window.addEventListener('resize', sync);
      sync();
    });
  })();

  // Bound to every [data-gw-suggest] on the page, not just the first: the
  // search page has one and the header's modal has another, and they are the
  // same thing so they run the same code.
  (function () {
    document.querySelectorAll('[data-gw-suggest]').forEach(function (scope) {
    var input = scope.querySelector('[data-gw-suggest-input]');
    var panel = scope.querySelector('[data-gw-suggest-panel]');
    if (!input || !panel) return;

    var MIN = 2;
    var timer = null;
    var controller = null;
    var index = -1;

    function rows() {
      return panel.querySelectorAll('.gw-suggest__row');
    }

    function close() {
      panel.hidden = true;
      panel.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      index = -1;
    }

    function highlight(next) {
      var list = rows();
      if (!list.length) return;
      if (index > -1 && list[index]) list[index].setAttribute('aria-selected', 'false');
      index = (next + list.length) % list.length;
      var row = list[index];
      row.setAttribute('aria-selected', 'true');
      // scroll the PANEL, not the page
      if (row.offsetTop < panel.scrollTop) panel.scrollTop = row.offsetTop;
      var bottom = row.offsetTop + row.offsetHeight;
      if (bottom > panel.scrollTop + panel.clientHeight) {
        panel.scrollTop = bottom - panel.clientHeight;
      }
    }

    function search(term) {
      // One request in flight at a time — typing fast otherwise races and the
      // slower answer can land last and overwrite the right one.
      if (controller) controller.abort();
      controller = new AbortController();

      // Section javascript is not run through Liquid, so the route arrives on
      // the element rather than being interpolated here — which also keeps it
      // right under a locale or market prefix.
      var url = (scope.getAttribute('data-gw-suggest-url') || '/search/suggest')
        + '?q=' + encodeURIComponent(term)
        + '&section_id=gw-predictive-search'
        + '&resources[type]=product'
        + '&resources[limit]=6';

      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var section = doc.querySelector('#shopify-section-gw-predictive-search');
          panel.innerHTML = section ? section.innerHTML : '';
          var has = panel.textContent.trim().length > 0;
          panel.hidden = !has;
          input.setAttribute('aria-expanded', has ? 'true' : 'false');
          index = -1;
        })
        .catch(function () { /* aborted, offline, or a bad response — stay quiet */ });
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      clearTimeout(timer);
      if (term.length < MIN) { close(); return; }
      // Long enough to not fire on every keystroke, short enough that the list
      // is already there by the time you stop typing.
      timer = setTimeout(function () { search(term); }, 180);
    });

    input.addEventListener('keydown', function (event) {
      if (panel.hidden) return;
      if (event.key === 'ArrowDown') { event.preventDefault(); highlight(index + 1); }
      else if (event.key === 'ArrowUp') { event.preventDefault(); highlight(index - 1); }
      // Escape closes the list. Inside the search modal a second Escape then
      // closes the dialog, because this one only acts while the list is open.
      else if (event.key === 'Escape') { event.stopPropagation(); close(); }
      else if (event.key === 'Enter' && index > -1) {
        var row = rows()[index];
        if (row) { event.preventDefault(); window.location.href = row.href; }
      }
    });

    document.addEventListener('click', function (event) {
      if (!scope.contains(event.target)) close();
    });

    input.addEventListener('focus', function () {
      var term = input.value.trim();
      if (term.length >= MIN && panel.hidden) search(term);
    });
    });
  })();


  // Remember what was looked at. Stored with everything a card needs rather
  // than just a handle, so the search page can draw them without a request —
  // and the price is kept as rendered, which preserves the display currency of
  // the domain it was seen on. This lives in the header because a section's
  // javascript only runs where that section is rendered, and the search
  // section is never on a product page.
  (function () {
    var seed = document.querySelector('[data-gw-viewed]');
    if (!seed) return;
    try {
      var item = JSON.parse(seed.textContent);
      if (!item || !item.url) return;
      var KEY = 'gw-recently-viewed';
      var list = [];
      try { list = JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { list = []; }
      list = list.filter(function (x) { return x && x.url !== item.url; });
      list.unshift(item);
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, 12)));
    } catch (e) { /* storage off, or a private window: not worth a fuss */ }
  })();

  // The drawing on a policy page. Shopify owns that markup, so this is the one
  // place on the site where a drawing is placed by script rather than by
  // Liquid — there is no template of ours to put it in.
  (function () {
    var container = document.querySelector('.shopify-policy__container');
    var source = document.querySelector('[data-gw-policy-art]');
    if (!container || !source) return;

    var handle = (window.location.pathname.split('/').filter(Boolean).pop() || '').toLowerCase();
    var art;
    try { art = JSON.parse(source.textContent)[handle]; } catch (e) { return; }
    if (!art) return;

    var img = document.createElement('img');
    img.className = 'gw-policy__icon';
    img.src = art;
    img.alt = '';                        // decorative; the heading names the page
    img.loading = 'eager';

    var title = container.querySelector('.shopify-policy__title');
    if (title && title.nextSibling) container.insertBefore(img, title.nextSibling);
    else container.appendChild(img);
    container.classList.add('gw-policy--iconed');
  })();

  /* ------------------------------------------------------------------
     Toast, and adding to the basket without leaving the page.
     ------------------------------------------------------------------ */
  (function () {
    var toast = document.querySelector('[data-gw-toast]');
    var text = toast && toast.querySelector('[data-gw-toast-text]');
    var timer = null;

    function say(message, tone) {
      if (!toast || !text) return;
      text.textContent = message;
      toast.classList.toggle('gw-toast--error', tone === 'error');
      toast.hidden = false;
      // Force a reflow so the browser takes the hidden state as the starting
      // point of the transition. requestAnimationFrame would do it too, but it
      // does not run in a background tab — and a toast that never appears
      // because the tab was not focused is worse than no animation.
      void toast.offsetWidth;
      toast.classList.add('is-up');

      clearTimeout(timer);
      timer = setTimeout(function () {
        toast.classList.remove('is-up');
        setTimeout(function () { toast.hidden = true; }, 260);
      }, tone === 'error' ? 5000 : 3000);
    }

    document.addEventListener('gw:toast', function (event) {
      say((event.detail && event.detail.message) || '', event.detail && event.detail.tone);
    });

    // The count is rendered by Liquid, so without this it only catches up on
    // the next page load — you add something, the basket opens with it in
    // there, and the header still says nothing is.
    function countCart() {
      var spots = document.querySelectorAll('[data-gw-cart-count]');
      if (!spots.length) return Promise.resolve();
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function (cart) {
          spots.forEach(function (spot) { spot.textContent = cart.item_count; });
        })
        .catch(function () { /* leave the old number rather than a wrong one */ });
    }

    // Anything that changes the basket says so, and the count follows.
    document.addEventListener('gw:cart:refresh', countCart);

    // Adding to the basket posts in place. The old behaviour — a full form
    // POST to /cart/add — answered with a redirect to the basket page, which
    // threw away the page someone was reading to show them a list.
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;

      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;
      if (!window.fetch || !window.FormData) return;          // let it post normally

      var drawer = document.getElementById('gw-cart-drawer');
      if (!drawer || typeof drawer.showModal !== 'function') return;

      event.preventDefault();

      var button = form.querySelector('[name="add"]');
      if (button) button.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (r) {
          return r.json().then(function (body) {
            return r.ok ? body : Promise.reject(body);
          });
        })
        .then(function (item) {
          var title = (item && (item.product_title || item.title)) || 'It';
          say(title + ' — added to your basket');
          countCart();

          // A modal <dialog> renders in the top layer, above everything the
          // page can put on screen — so the drawer would cover the toast the
          // instant it opened. Let the confirmation be read first, then show
          // the basket.
          setTimeout(function () {
            document.dispatchEvent(new CustomEvent('gw:cart:refresh', { detail: { open: true } }));
          }, 850);
        })
        .catch(function (err) {
          // Shopify puts the real reason in `description` — usually that there
          // is not enough stock left. Saying that is more use than "failed".
          var why = (err && (err.description || err.message)) || 'That did not go through. Try again?';
          say(why, 'error');
        })
        .then(function () {
          if (button) button.disabled = false;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  /* The steppers and the remove link work with JavaScript off — they are plain
     /cart/change links. This only upgrades them: instead of navigating away and
     throwing out anything typed into the order note, it writes the new quantity
     into the matching updates[] field and submits the basket form. */
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-gw-qty-link]');
    if (!link) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (event.button !== 0) return;

    var form = link.closest('form');
    if (!form) return;

    var row = link.closest('.gw-basket__item');
    var input = row && row.querySelector('.gw-qty__input');
    if (!input) return;

    var update = form.querySelector('[data-gw-basket-update]');
    if (!update) return;

    event.preventDefault();
    input.value = link.getAttribute('data-gw-qty-value');
    update.click();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  // Sort genuinely submits: the <select> is a real GET control, and this only
  // saves the visitor a press of Apply. Without JS the noscript button does it.
  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-gw-sort]');
    if (!select || !select.form) return;
    select.form.submit();
  });

  // Let the filter disclosure behave like one: click away or press Escape.
  document.addEventListener('click', function (event) {
    var open = document.querySelectorAll('[data-gw-filter][open]');
    for (var i = 0; i < open.length; i++) {
      if (!open[i].contains(event.target)) open[i].removeAttribute('open');
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelectorAll('[data-gw-filter][open]');
    for (var i = 0; i < open.length; i++) {
      open[i].removeAttribute('open');
      var summary = open[i].querySelector('summary');
      if (summary) summary.focus();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-gw-gallery]').forEach(function (gallery) {
      var track = gallery.querySelector('[data-gw-gallery-track]');
      if (!track) return;

      var slides = gallery.querySelectorAll('.gw-gallery__slide');
      var prev = gallery.querySelector('[data-gw-gallery-prev]');
      var next = gallery.querySelector('[data-gw-gallery-next]');
      var thumbs = gallery.querySelectorAll('[data-gw-gallery-thumb]');
      if (!slides.length) return;

      // Everything here reads the track's own overflow rather than a
      // breakpoint, so the desktop grid — which cannot scroll sideways —
      // quietly reports index 0 and the controls it does not render stay out
      // of it. One source of truth instead of a media query in two places.
      function step() {
        return track.clientWidth || 1;
      }
      function index() {
        return Math.round(track.scrollLeft / step());
      }

      // scrollTo on the TRACK, never scrollIntoView and never focus() on a
      // slide: both of those scroll the PAGE back up to the gallery, which is
      // exactly the jump a thumbnail tap must not cause.
      function go(i) {
        var clamped = Math.max(0, Math.min(i, slides.length - 1));
        track.scrollTo({ left: clamped * step(), behavior: 'smooth' });
      }

      function sync() {
        var i = index();
        thumbs.forEach(function (thumb, n) {
          thumb.setAttribute('aria-current', n === i ? 'true' : 'false');
        });
        if (prev) prev.disabled = i <= 0;
        if (next) next.disabled = i >= slides.length - 1;
      }

      if (prev) prev.addEventListener('click', function () { go(index() - 1); });
      if (next) next.addEventListener('click', function () { go(index() + 1); });
      thumbs.forEach(function (thumb, n) {
        thumb.addEventListener('click', function () { go(n); });
      });

      // Snap scrolling fires a lot; one frame is plenty to keep the dots and
      // the arrow states honest.
      var frame = null;
      track.addEventListener('scroll', function () {
        if (frame) return;
        frame = requestAnimationFrame(function () {
          frame = null;
          sync();
        });
      }, { passive: true });

      window.addEventListener('resize', sync);
      sync();
    });
  })();

  (function () {
    var bar = document.querySelector('[data-gw-buybar]');
    var cta = document.querySelector('[data-gw-cta]');
    if (!bar || !cta || !('IntersectionObserver' in window)) return;

    bar.hidden = false;

    function show(up) {
      bar.classList.toggle('is-up', up);
    }

    // rootMargin trims the viewport by the bar's own height, so the bar never
    // rises to cover the very button it is standing in for.
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        show(!entry.isIntersecting);
      });
    }, { rootMargin: '0px 0px -84px 0px', threshold: 0 });

    observer.observe(cta);
  })();

  (function () {
    var rows = document.querySelectorAll('.gw-acc__row');
    if (!rows.length) return;

    // Opening a row glides just far enough to bring the rest of its text into
    // view. Closing does nothing — collapsing already moves everything under
    // your cursor, and moving the page as well would be two surprises at once.
    function reveal(row) {
      var column = row.closest('.gw-pdp__info');
      var scrolls = column
        && column.scrollHeight > column.clientHeight + 1
        && getComputedStyle(column).overflowY === 'auto';

      var rect = row.getBoundingClientRect();
      var margin = 14;

      if (scrolls) {
        var box = column.getBoundingClientRect();
        var below = rect.bottom - box.bottom + margin;
        // Never travel so far that the summary you just clicked leaves the top.
        var room = rect.top - box.top;
        if (below > 0) column.scrollBy({ top: Math.min(below, room), behavior: 'smooth' });
        return;
      }

      // The page is the scroller. On a phone the sticky buy bar owns the
      // bottom strip, so the row has to clear that too.
      var bar = document.querySelector('.gw-buybar.is-up');
      var floor = window.innerHeight - (bar ? bar.offsetHeight : 0);
      var overflow = rect.bottom - floor + margin;
      var headroom = rect.top - 8;
      if (overflow > 0) window.scrollBy({ top: Math.min(overflow, headroom), behavior: 'smooth' });
    }

    rows.forEach(function (row) {
      row.addEventListener('toggle', function () {
        if (!row.open) return;
        // One frame, so the panel has its height before anything is measured.
        requestAnimationFrame(function () { reveal(row); });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  // The search page answers in its own grid. Typing replaces it; clearing the
  // field puts back what was there before — recently viewed, then the picks.
  (function () {
    var scope = document.querySelector('[data-gw-search-url]');
    if (!scope) return;

    var input = scope.querySelector('[data-gw-search-input]');
    var live = document.querySelector('[data-gw-search-live]');
    var panes = document.querySelectorAll('[data-gw-search-pane]');
    if (!input || !live) return;

    var MIN = 2;
    var timer = null;
    var controller = null;

    function showPanes(on) {
      panes.forEach(function (pane) {
        // A pane that was hidden for its own reasons — no recently viewed —
        // must stay hidden, so its own flag is remembered separately.
        if (pane.hasAttribute('data-gw-empty')) return;
        pane.hidden = !on;
      });
    }

    function clear() {
      live.hidden = true;
      live.innerHTML = '';
      showPanes(true);
    }

    function search(term) {
      if (controller) controller.abort();
      controller = new AbortController();

      // The real search, not /search/suggest: suggest stops at ten however
      // many things match, and this grid is meant to be everything.
      var url = (scope.getAttribute('data-gw-search-url') || '/search')
        + '?q=' + encodeURIComponent(term)
        + '&type=product'
        + '&options%5Bprefix%5D=last'
        + '&section_id=gw-search-grid';

      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var section = doc.querySelector('#shopify-section-gw-search-grid');
          live.innerHTML = section ? section.innerHTML : '';
          var has = live.textContent.trim().length > 0;
          live.hidden = !has;
          showPanes(!has);
        })
        .catch(function () { /* aborted or offline: leave what is there */ });
    }

    // With the grid answering live there is nothing left for a submit to do
    // but reload the page onto the same answer, so the form stays put.
    var form = input.form;
    if (form) {
      form.addEventListener('submit', function (event) {
        if (input.value.trim().length >= MIN) event.preventDefault();
      });
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      clearTimeout(timer);
      if (term.length < MIN) { clear(); return; }
      timer = setTimeout(function () { search(term); }, 180);
    });
  })();

  // Draw the recently viewed. The recording happens in the header, because a
  // section's javascript only runs on pages where that section is rendered —
  // this one is never on a product page, which is the only place there is
  // anything to record.
  (function () {
    var KEY = 'gw-recently-viewed';
    var MAX = 4;

    function read() {
      try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
    }

    var pane = document.querySelector('[data-gw-recent]');
    var grid = document.querySelector('[data-gw-recent-grid]');
    if (!pane || !grid) return;

    var items = read().slice(0, MAX);
    if (!items.length) {
      // Nothing seen yet. Flag it so the live search does not later reveal an
      // empty heading when the field is cleared.
      pane.setAttribute('data-gw-empty', '');
      return;
    }

    items.forEach(function (item) {
      var a = document.createElement('a');
      a.className = 'gw-card';
      a.href = item.url;

      var media = document.createElement('div');
      media.className = 'media media--4x5 card__media';
      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = '';
        img.loading = 'lazy';
        media.appendChild(img);
      }

      var title = document.createElement('h3');
      title.className = 'card__title';
      title.textContent = item.title || '';

      var price = document.createElement('p');
      price.className = 'card__price';
      price.textContent = item.price || '';

      a.appendChild(media);
      a.appendChild(title);
      a.appendChild(price);
      grid.appendChild(a);
    });

    pane.hidden = false;
  })();


  // Sorting submits on change. The Apply button is the no-JS fallback and is
  // removed here rather than hidden in CSS, so it never sits in the tab order.
  document.querySelectorAll('[data-gw-search-controls]').forEach(function (form) {
    var apply = form.querySelector('[data-gw-search-apply]');
    if (apply) apply.remove();

    form.querySelectorAll('select').forEach(function (select) {
      select.addEventListener('change', function () {
        form.submit();
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
